<template>
  <div class="CrudList d-flex">
    <transition
      @enter="enter"
      @leave="leave"
    >
      <div class="list-content p-4">
        <div class="d-flex flex-column">
          <div v-if='formInputPlaceholder' class="header">
            <div class="input-wrapper">
              <FormInput v-model.trim="search"
                class="input"
                :placeholder="formInputPlaceholder"
              />

              <span class="adder" @click="add">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                </svg>
              </span>
            </div>
          </div>
          <div v-else class='header'>
            <button class="d-flex align-items-center" @click="add">
              <svg xmlns="http://www.w3.org/2000/svg" width='14' height='14' viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
              </svg>
              <span class='ml-2'>{{ adderTitle }}</span>
            </button>
          </div>
          <ul v-if="loadingItems" class="mb-4">
            <CrudItem v-for="item in placeholder" :key="item.uid"
              v-bind="item"
              :loadingItems="loadingItems"
            />
          </ul>
          <ul v-else-if="items && items.length" class="disable-ske scrolling-wrapper">
            <InfiniteScrolling
              :searchMore="searchMore"
              :showEnd="showEnd"
            >
              <transition-group
                @enter="enter"
                @leave="leave"
              >
                <CrudItem v-for="item in items" :key="item.uid"
                  class="drag-handle"
                
                  v-bind="item"
                  :selectable='selectable'
                  :actionTitle='actionTitle'
                  :showDate='showDate'
                  :editable='editable'
                  :active="selected === item.uid"
                  :loadingItems="loadingItems"

                  @edit="edit(item)"
                  @select="selected = item.uid"
                  @remove="remove(item)"
                  @action="$emit('action', item)"
                />
              </transition-group>
            </InfiniteScrolling>
          </ul>
          <ul v-else class="d-flex align-items-center justify-content-center empty-state-wrapper" key="empty-staet">
            <slot>
              <EmptyStatePlaceholder
                :title="titleEmptyPlaceholder"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </EmptyStatePlaceholder>
            </slot>
          </ul>
        </div>
      </div>
    </transition>
    <!-- <div class='cms-website-box'>
      <CmsWebsite v-if="selected !== null" :websiteId="websiteUid" :selectedPageId="selected"/>
    </div> -->
  </div>
</template>

<script>

import FormInput from "../../../../components/Inputs/FormInput.vue"
import CrudItem from "./CrudItem.vue"
// import CmsWebsite from "../../CmsWebsite.vue"
import EmptyStatePlaceholder from "../../../../layout/EmptyStatePlaceholder.vue"
import InfiniteScrolling from "../../../../layout/InfiniteScrolling.vue"

import transitionFunctionConstructor from "../../../../mixins/transitionFunctionConstructor"

export default {
  props: {
    opened: Boolean,
    showDate: Boolean,
    cached: Boolean,
    formInputPlaceholder: String,
    label: String,
    editTitle: String,
    addTitle: String,
    adderTitle: String,
    actionTitle: String,
    confirmDelete: Function,
    pageSize: {
      default: 10,
      type: Number,
    },
    selectable: {
      default: true,
      type: Boolean,
    },
    editable: {
      default: true,
      type: Boolean,
    },

    type: String,
    endpoint: Function,
    addSuccessMessage: String,
    editSuccessMessage: String,

    titleEmptyPlaceholder: String,
  },
  components: {
    // CmsWebsite,
    EmptyStatePlaceholder,
    CrudItem,
    InfiniteScrolling,
    FormInput,
  },
  mixins: [
    transitionFunctionConstructor("enter", "leave", "width"),
  ],
  beforeDestroy() {
    this.search = ""
  },
  created() {
    this.fetchAndReset()
  },
  data() {
    return {
      search: "",
      selected: null,
      
      placeholder: [
        {
          name: "Jani ash",
          id: "jan2",
        },
        {
          name: "Jani ash thnsaeio",
          id: "jan",
        },
        {
          name: "Jani ash",
          id: "jan",
        },
        {
          name: "Jani ash thnsaeio",
          id: "jan",
        },
        {
          name: "Jani ash",
          id: "jan",
        },
        {
          name: "Jani ash",
          id: "jan2",
        },
        {
          name: "Jani ash thnsaeio",
          id: "jan",
        },
        {
          name: "Jani ash",
          id: "jan",
        },
        {
          name: "Jani ash thnsaeio",
          id: "jan",
        },
        {
          name: "Jani ash",
          id: "jan",
        },
      ],
      items: [],

      loadingItems: false,
      showEnd: false,
    }
  },
  methods: {
    async fetchAndReset() {
      this.loadingItems = true

      this.items = await this.fetchItems()
      this.showEnd = this.items.length >= this.pageSize
      if (this.selectable) {
        this.selected = this.items[0] && this.items[0].uid
      }

      this.loadingItems = false
    },
    async searchMore(page = 1) {
      const newItems = await this.fetchItems(page)
      
      this.items.push(...newItems)

      return newItems.length < this.pageSize
    },
    async fetchItems(page = 1) {
      const options = {
        params: {
          page,
          page_size: this.pageSize,

          name: this.search,
          type: this.type,
        },
      }

      let res
      if (this.cached) {
        res = (await this.$store.dispatch("cachedGet", {
          endpoint: this.mainEndpoint,
          params: options,
        })).data
      } else {
        res = (await this.axios.get(this.mainEndpoint, options)).data
      }

      let result
      if (res && res.rows) {
        result = res.rows
      } else {
        result = res.results
      }
      this.$emit("on-fetch", result)
      
      return result
    },

    add() {
      this.$pushModal({
        modal: "SimpleTextFieldModalTemplate",
        toBind: {
          label: this.label,
          editTitle: this.editTitle,
          addTitle: this.addTitle,

          addCallback: async name => {
            this.loadingItems = true

            await this.axios.post(this.mainEndpoint, {
              name,
              type: this.type,
            })
            this.fetchAndReset()

            this.$success(this.addSuccessMessage)
          },
        },
      })
    },
    edit({name, uid}) {
      this.$pushModal({
        modal: "SimpleTextFieldModalTemplate",
        toBind: {
          label: this.label,
          editTitle: this.editTitle,
          addTitle: this.addTitle,

          name,

          editCallback: async newName => {
            this.loadingItems = true

            await this.axios.put(`${this.mainEndpoint}/${uid}`, {
              name: newName,
              type: this.type,
            })
            this.fetchAndReset()

            this.$success(this.editSuccessMessage)
          },
        },
      })
    },
    remove(item) {
      const deleteItem = async () => {
        return await this.$handlePromise(async () => {
          await this.axios.delete(`${this.mainEndpoint}/${item.uid}`)
          this.$success("Item succesvol verwijderd!")
          this.fetchAndReset()
        })
      }

      if (!this.confirmDelete) {
        deleteItem()
      } else {
        this.$store.commit("pushModal", {
          toBind: {
            ...this.confirmDelete(item),
            callback: async () => await deleteItem(),
          },
          modal: "ConfirmAction",
        })
      }
    },
  },
  computed: {
    websiteUid() {
      return this.$route.params.id
    },
    mainEndpoint() {
      if (this.endpoint) {
        return this.endpoint(this.websiteUid)
      }
      return `/api/websites/${this.websiteUid}/pages`
    },
  },
  watch: {
    search() {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.timeout = setTimeout(this.fetchAndReset, 300)
    },
  },
}

</script>

<style scoped>

button {
  border-radius: 6px;
  font-weight: 500;
  padding: 8px 12px;
  color: var(--primary);
  border: 1px solid rgb(228,228,228);
}

button:hover {
  background-color: rgb(251,251,251);
}

.CrudList, .list-content {
  flex-basis: 100%;
}

.list-content, .list-content > div, .CrudList {
  height: 100%;
}

.scrolling-wrapper {
  height: 100%;
  overflow: auto;
}

.empty-state-wrapper {
  flex-grow: 1;
}

.header {
  padding-bottom: 14px;
}

.input-wrapper {
  position: relative;
}

.adder {
  position: absolute;
  padding: 4px;
  margin-right: 6px;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background-color: #f8f9fa;
  cursor: pointer;
  border-radius: 1px;
  transition-duration: .15s;
}

.adder:hover {
  background-color: #EFF6FF;
  color: #0081c7;
}

.cms-website-box {
  width: 100%;
}

</style>
